module.exports = __webpack_public_path__ + "img/canvas_image_10.faafb79.jpg";